import createClient from "openapi-react-query"

import { createApiClient } from "@/api/utils"
import { env } from "@/env"
import type { paths as boardsPaths } from "@/types/api/boards/schema.gen"

const client = createApiClient<boardsPaths>({
  baseUrl: `${env.VITE_API2_URL}/boards`
})

// Vanilla API client
export const $boardsApiClient = client.vanillaClient

// React-Query client
export const $rqBoardsApiClient = createClient(client.rqClient)
